import { _ } from "../polyglot/polyglot.js";
import dialog from "./dialog.js";
import ImageChooserWidget from "./ImageChooserWidget.js";

/**
 * Dialog offering to choose and crop an image.
 *
 * @param {Renderable} [spec.confirmLabel] - Label of the confirmation
 * button, 'Confirm' by default
 * @param {Renderable} [spec.cancelLabel] - Label of the cancel button,
 * 'Cancel' by default
 * @param {number} spec.height - Output height
 * @param {number} spec.width - Output width
 * @param {boolean} spec.rounded - True if the output is rounded
 * @param {boolean} spec.highResolution - True if the image should be HDPI compatible
 */
export default dialog.subclass((that, my) => {
	my.initialize = function ({
		confirmLabel = _("Confirm"),
		cancelLabel = _("Cancel"),
		height,
		width,
		highResolution,
		rounded,
	}) {
		my.super(...arguments);
		my.confirmLabel = confirmLabel;
		my.cancelLabel = cancelLabel;

		my.imageChooserWidget = new ImageChooserWidget({
			height,
			width,
			highResolution,
			rounded,
		});
	};

	my.createEvents("onChoose", "onCancel");

	my.renderBodyOn = function (html) {
		html.div({ klass: "modal-body" }, my.imageChooserWidget);
	};

	my.footerRenderOn = function (html) {
		html.div(
			{ klass: "modal-footer" },
			html.button(
				{
					klass: "btn btn-primary",
					"data-test": "confirm",
					click: () => my.confirm(),
				},
				my.confirmLabel,
			),
			html
				.button({ klass: "btn btn-default" }, my.cancelLabel)
				.click(() => {
					my.cancel();
				}),
		);
	};

	my.confirm = function () {
		that.hide();
		const data = my.imageChooserWidget.getData();
		that.onChoose.trigger(data);
	};

	my.cancel = function () {
		that.hide();
		that.onCancel.trigger();
	};
});
